import { ParamIds, Places } from '../../../Constants'
import GrupoKeys from '../grupo.keys'

export class GrupoFormKeys extends GrupoKeys {
    get place() {
        return Places.grupoForm
    }

    get grupoId() {
        return this._intent.getParameterAsNumber(ParamIds.grupoFormId)
    }

    set grupoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.grupoFormId, value)
    }

    get addAnaliseId() {
        return this._intent.getParameterAsNumber(ParamIds.analiseSelectId)
    }

    set addAnaliseId(value: number | undefined) {
        this._intent.setParameter(ParamIds.analiseSelectId, value)
    }
}
